import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { ICrmPhuHuynhActionTypes } from "../../action-types/crm-phuhuynh/ICrmPhuHuynhActionTypes";
import { ICrmPhuHuynhReducer } from "../../page-state-model/crm-phuhuynh/ICrmPhuHuynhReducer";

const iniState: ICrmPhuHuynhReducer = {
    status: ePageBaseStatus.is_not_initialization,
    PhuHuynhs: [],
    PhuHuynhSelectedIds: []
};

export const crmPhuHuynhReducer = (state: ICrmPhuHuynhReducer = iniState, action: ICrmPhuHuynhActionTypes): ICrmPhuHuynhReducer => {
    switch (action.type) {
        case "CRM_PHU_HUYNH_LOAD_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            };
        case "CRM_PHU_HUYNH_LOAD_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                PhuHuynhs: action.payload
            };
        case "CRM_PHU_HUYNH_LOAD_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                PhuHuynhs: []
            };
        case "CRM_PHU_HUYNH_CHANGE_SELECTED_IDS":
            return {
                ...state,
                PhuHuynhSelectedIds: action.payload
            };
        default:
            return state;
    }
};
